import { useEffect, useRef, type RefObject } from 'react';

/** Put the cursor back in a chat composer once the model's reply has landed.
 *
 *  The composer is disabled while a turn streams, and disabling a focused
 *  element blurs it — so without this you have to click back into the box
 *  before typing the next message. Fires only on the streaming true→false
 *  transition, so it never steals focus on mount or on unrelated renders. */
export function useRefocusAfterStreaming(
  ref: RefObject<HTMLTextAreaElement | null>,
  isStreaming: boolean,
) {
  const wasStreaming = useRef(false);

  useEffect(() => {
    if (wasStreaming.current && !isStreaming) {
      ref.current?.focus();
    }
    wasStreaming.current = isStreaming;
  }, [isStreaming, ref]);
}
